/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pricing_Choose_Payment_DescInputs */

const en_common_pricing_choose_payment_desc = /** @type {(inputs: Common_Pricing_Choose_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick how you'd like to pay.`)
};

const zh_common_pricing_choose_payment_desc = /** @type {(inputs: Common_Pricing_Choose_Payment_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择你想使用的支付渠道。`)
};

/**
* | output |
* | --- |
* | "Pick how you'd like to pay." |
*
* @param {Common_Pricing_Choose_Payment_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_pricing_choose_payment_desc = /** @type {((inputs?: Common_Pricing_Choose_Payment_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pricing_Choose_Payment_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_pricing_choose_payment_desc(inputs)
	return zh_common_pricing_choose_payment_desc(inputs)
});
export { common_pricing_choose_payment_desc as "common.pricing.choose_payment_desc" }